export const AdminUiEnvController = {
    index(): void {},
};
